export default __webpack_public_path__ + "a1980be535d5826b5693d0bfe46df89a.svg";